import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Data considered fresh for 5 minutes (won't refetch automatically)
            staleTime: 5 * 60 * 1000,
            // Cache data for 30 minutes before garbage collection
            gcTime: 30 * 60 * 1000,
            // Retry failed requests up to 2 times
            retry: 2,
            // Don't refetch on window focus for dashboard data
            refetchOnWindowFocus: false,
            // Don't refetch on reconnect automatically
            refetchOnReconnect: false,
        },
    },
});
